import React, { Fragment, useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";

import { ConvertDate } from "../../../Function/ConvertDate";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import axios from "axios";
import Lottie from "react-lottie";
import * as deleteTrash from "../../../../assets/lottieAnimation/delete.json";
import { CheckBudgetYear } from "../../../Function/CheckBudgetYear";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import { Tooltip } from "@mui/material";
import SubMenuEntryWork from "../../SubMenuEntryWork";
import MyThaiDatePick from "../../../../components/Common/ThaiDatePicker";
import { CheckSubAdmin } from "../../../Function/CheckSubAdmin";
import { CheckPosition } from "../../../Function/CheckPosition";
import classnames from "classnames";
import EmployeeView from "./EmployeeView";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";
import dayjs from "dayjs";
import { leaveStatusBadge } from "../../../Function/LeaveStatusBadge";

const Menu5 = ({ userInfo }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const budgetYear = CheckBudgetYear();

  const [holiday, setHoliday] = useState([]);
  const [dataForm16, setDataForm16] = useState([]);
  const [dataEdit, setDataEdit] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [totalPage, setTotalPage] = useState();
  const [totalRows, setTotalRows] = useState();
  const [editModal, setEditModal] = useState(false);
  const [confirmSend, setConfirmSend] = useState(false);
  const [modalCancel, setModalCancel] = useState({
    modal: false,
    status: "",
  });

  const [leaveTime, setLeaveTime] = useState("T13:00:00.000Z")
  const [editLeaveTime, setEditLeaveTime] = useState("T13:00:00.000Z")
  const [data, setData] = useState({
    //show in form only
    user_id: userInfo?.user_id,
    user_name: userInfo?.user_name,
    user_position_name: userInfo?.user_position_name,
    cont_to_name_1: userInfo?.cont_to_name_1,
    writeFrom: "สำนักงาน ก.พ.ร.",
    writeDate: new Date().toLocaleDateString(),

    //required field
    leave_type_id: 16,
    form_type: 12,
    form_name: "ออกงานก่อนเวลา",
    budget_year: budgetYear,
    leave_name: "ขออนุญาตออกงานก่อนเวลา",
    send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
    leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
    leave_from_timetype: "1",
    leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
    leave_to_timetype: "2",
    leave_days: null,
    leave_status: "4",
    approve_status: "0",
    approve_user_id: userInfo?.leader?.user_id,
    approve_user: userInfo?.leader?.user_name,
    leave_reason: "",
  });
  const [position, setPosition] = useState(false)
  const [searchData, setSearchData] = useState({
    startDate: new Date(),
    toDate: new Date(),
    department: "",
    groupName: "",
    empName: "",
    empNamID: "",
    fileType: "1",
    reportType: "1",
  });

  const [checkHoliday, setCheckHoliday] = useState(false)

  const getHoliday = async (year) => {
    try {
      const res = await axios.get(baseURL + `/api/masterdata/holiday/${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setHoliday(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      leave_days: calculateLeaveDays(
        data?.leave_from_date,
        data?.leave_from_timetype,
        data?.leave_to_date,
        data?.leave_to_timetype
      ),
    }));
    setLeaveDataFromSelect([])
    getHoliday(new Date()?.getFullYear());
  }, []);

  useEffect(() => {
    if (userInfo) {
      setData((prev) => ({
        ...prev,
        //show in form only
        user_id: userInfo?.user_id,
        user_name: userInfo?.user_name,
        user_position_name: userInfo?.user_position_name,
        cont_to_name_1: userInfo?.cont_to_name_1,
        writeFrom: "สำนักงาน ก.พ.ร.",
        writeDate: new Date().toLocaleDateString(),

        //required field
        leave_type_id: 16,
        form_type: 12,
        form_name: "ออกงานก่อนเวลา",
        budget_year: budgetYear,
        leave_name: "ขออนุญาตออกงานก่อนเวลา",
        send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
        leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_from_timetype: "1",
        leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_to_timetype: "2",
        leave_days: calculateLeaveDays(
          new Date(new Date().setHours(0, 0, 0, 0)),
          "1",
          new Date(new Date().setHours(0, 0, 0, 0)),
          "2"
        ),
        leave_status: "4",
        approve_status: "0",
        approve_user_id: userInfo?.leader?.user_id,
        approve_user: userInfo?.leader?.user_name,
        leave_reason: "",
      }));
      
      // if (CheckSubAdmin(userInfo?.positionSubAdmin)) {
      //   setPosition("admin")
      // } else if (CheckPosition(userInfo?.position)) {
      //   setPosition("leader")
      // } else {
      //   setPosition("normol");
      // }
      
      // if (CheckPosition(userInfo?.position)) {
      //   const checkPo = CheckPosition(userInfo?.position)
      //   if (checkPo?.includes(1)) {
      //     setPosition("admin")
      //   } else if (checkPo?.includes(5) || checkPo?.includes(4) || checkPo?.includes(3) || checkPo?.includes(2)) {
      //     setPosition("Highleader")
      //   }
      //   else if(checkPo?.includes(7)){
      //     setPosition("leader")
      //   }
      //   // setPosition("leader")
      // } else {
      //   // const checkSub = CheckSubAdmin(userInfo?.positionSubAdmin)
      //   // if (checkSub?.includes(0) || checkSub?.includes(2)) {
      //   //   setPosition("leader")
      //   // } else {
      //     setPosition("normol");
      //   // },
      // }
      
    }
  }, [userInfo]);

  const calculateLeaveDays = (
    leavefromDate,
    leavefromTime,
    leavetoDate,
    leavetoTime
  ) => {

    let sum = 0;
    
    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    if (leavefromTime === "1" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0;
      return sum;
    }
    if (leavefromTime === "1" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 1;
      return sum;
    }
  };

  const toggleConfirm = () => {
    setConfirmSend(!confirmSend);
  };

  const toggleModal = () => {
    if (editModal === true) {
      // setDataEdit({});
      setEditModal(!editModal);
    } else {
      setEditModal(!editModal);
    }
  };

  const [insertModal, setInsertModal] = useState(false)

  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        `${baseURL}/api/leave/save`,
        {
          leave_type_id: data?.leave_type_id, //ประเภทใบลา
          form_type: data?.form_type, //ประเภทฟอร์มการลา
          form_name: data?.form_name, //ชื่อฟอร์มการลา
          budget_year: data?.budget_year, //ปีงบประมาณ
          leave_name: data?.leave_name, //ชื่อเรื่องการลา
          send_to: data?.send_to, //เรียน
          leave_from_date: `${ConvertDate(data?.leave_from_date)?.toOnlyDateISO()}${leaveTime}`, //ตั้งแต่วันที่
          leave_from_timetype: data?.leave_from_timetype, //ช่วงเวลา
          leave_to_date:  `${ConvertDate(data?.leave_to_date)?.toOnlyDateISO()}${leaveTime}`, //ถึงวันที่
          leave_to_timetype: data?.leave_to_timetype, //ช่วงเวลา
          leave_days: data?.leave_days, //กำหนดหรือจำนวนวัน

          leave_reason: data?.leave_reason,
          note: data?.note || "", //หมายเหตุ
          user_id: data?.user_id, //ไอดีผู้ส่งฟอร์ม
          leave_status: data?.leave_status, //สถานะใบลา
          approve_status: data?.approve_status, //สถานะการอนุมัติ
          approve_user_id: data?.approve_user_id,
          approve_user: data?.approve_user,
          approve_final: 0,
          change_days: data?.leave_days,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await getForm16DataTable();
      toggleConfirm();
      setData((prev) => ({
        ...prev,
        form_type: 12,
        form_name: "ออกงานก่อนเวลา",
        budget_year: CheckBudgetYear(),
        leave_name: "ขออนุญาตออกงานก่อนเวลา",
        send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
        leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_from_timetype: "1",
        leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
        leave_to_timetype: "2",
        leave_days: calculateLeaveDays(
          new Date(new Date().setHours(0, 0, 0, 0)),
          "1",
          new Date(new Date().setHours(0, 0, 0, 0)),
          "2"
        ),
        leave_reason: "",
      }));
      setInsertModal(false)
    } catch (err) {
      console.error(err);
    }
  };

  const [dateFilter,setDateFilter] = useState({
    fromDate : null,
    toDate : null,
    isValid : false,
  })

  const getForm16DataTable = async (subAdmin = null, pages = 1) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: pages,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[leave_type_id][0]": 16,
      });
      !subAdmin && params.append("filter[user_id][0]", user_id);
      dateFilter.fromDate && params.append("filter[leave_dmy_start][0]", dateFilter.fromDate);
      dateFilter.toDate && params.append("filter[leave_dmy_end][0]", dateFilter.toDate);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      
      const res = await axios.get(url, config);
      setDataForm16(res?.data?.result);
      setCurrentPage(res?.data?.info?.currentPage);
      setTotalPage(res?.data?.info?.totalPage);
      setTotalRows(res?.data?.info?.totalRows);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true);
  }, []);

  const getDataForm16ByID = (id) => {
    let findData = dataForm16.find((item) => item.leave_data_id === id);
    setDataEdit((prev) => ({
      ...prev,
      approve_status: findData?.approve_status,
      approve_user: findData?.approve_user,
      approve_user_id: findData?.approve_user_id,
      budget_year: findData?.budget_year,
      form_name: findData?.form_name,
      form_type: findData?.form_type,
      cont_to_id: findData?.cont_to_id,
      leave_data_id: findData?.leave_data_id,
      leave_type_id: findData?.leave_type_id,
      leave_days: findData?.leave_days,
      // leave_days: 1,
      leave_from_date: findData?.leave_from_date,
      leave_from_timetype: findData?.leave_from_timetype,
      leave_name: findData?.leave_name,
      leave_reason: findData?.leave_reason,
      leave_status: findData?.leave_status,
      leave_to_date: findData?.leave_to_date,
      leave_to_timetype: findData?.leave_to_timetype,
      send_to: findData?.send_to,
      user_id: findData?.user_id,
      write_date: findData?.write_date,
      write_place: findData?.write_place,
    }));
  };

  const handleEdit = async (id) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${id}`,
        {
          leave_type_id: dataEdit?.leave_type_id,
          form_type: dataEdit?.form_type,
          form_name: dataEdit?.form_name,
          budget_year: dataEdit?.budget_year,
          leave_name: dataEdit?.leave_name,
          send_to: dataEdit?.send_to,
          leave_from_date: `${ConvertDate(dataEdit?.leave_from_date)?.toOnlyDateISO()}${editLeaveTime}`,
          leave_from_timetype: dataEdit?.leave_from_timetype,
          leave_to_date: `${ConvertDate(dataEdit?.leave_to_date)?.toOnlyDateISO()}${editLeaveTime}`,
          leave_to_timetype: dataEdit?.leave_to_timetype,
          leave_days: dataEdit?.leave_days,
          user_id: dataEdit?.user_id,
          leave_reason: dataEdit?.leave_reason,
          leave_status: dataEdit?.leave_status,
          approve_status: dataEdit?.approve_status,
          approve_user_id: dataEdit?.approve_user_id,
          approve_user: dataEdit?.approve_user,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await getForm16DataTable();
    } catch (err) {
      console.error(err);
    }
  };

  let reportURL = "";
  const handleGetReport = async (reportType, leaveDataId) => {
    try {
      const res = await axios.get(
        baseURL +
          `/api/report/leave/pdf/${reportType}/${leaveDataId}?mode=path`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      reportURL = res?.data?.path;
    } catch (err) {
      console.error(err);
    }
  };

  const resetData = () => {
    setData((prev) => ({
      ...prev,
      user_id: userInfo?.user_id,
      user_name: userInfo?.user_name,
      user_position_name: userInfo?.user_position_name,
      cont_to_name_1: userInfo?.cont_to_name_1,
      writeFrom: "สำนักงาน ก.พ.ร.",
      writeDate: new Date().toLocaleDateString(),

      //required field
      leave_type_id: 16,
      form_type: 12,
      form_name: "ออกงานก่อนเวลา",
      budget_year: CheckBudgetYear(),
      leave_name: "ขออนุญาตออกงานก่อนเวลา",
      send_to: "ผู้อำนวยการสำนักงานเลขาธิการ",
      leave_from_date: new Date(new Date().setHours(0, 0, 0, 0)),
      leave_from_timetype: "1",
      leave_to_date: new Date(new Date().setHours(0, 0, 0, 0)),
      leave_to_timetype: "2",
      leave_days: calculateLeaveDays(
        new Date(new Date().setHours(0, 0, 0, 0)),
        "1",
        new Date(new Date().setHours(0, 0, 0, 0)),
        "2"
      ),
      leave_status: "4",
      approve_status: "0",
      approve_user_id: userInfo?.leader?.user_id,
      approve_user: userInfo?.leader?.user_name,

      //non required field
      leave_reason: "",
      contact_address: "",
      abroad_for: "",
      abroad_country: "",
      abroad_ref: "",
      abroad_ref_2: "",
      ordinate_ever: "",
      ordinate_temple: "",
      ordinate_temple_place: "",
      ordinate_date: "",
      ordinate_live_temple: "",
      ordinate_live_place: "",
      hujj_ever: "",
      conscription_from: "",
      conscription_place: "",
      conscription_date: "",
      conscription_for: "",
      conscription_to_place: "",
      training_fund_from: "",
      spouse_name: "",
      spouse_position: "",
      spouse_department: "",
      spouse_country: "",
      spouse_from_date: "",
      spouse_to_date: "",
      spouse_years: "",
      spouse_months: "",
      spouse_days: "",
      outside_place: "",
      practice_type: "",
      practice_reason: "",

      note: "",
    }));
  };

  const handleCancelLeave = async (id, status) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${id}`,
        {
          leave_type_id: dataEdit?.leave_type_id,
          form_type: dataEdit?.form_type,
          form_name: dataEdit?.form_name,
          budget_year: dataEdit?.budget_year,
          leave_name: dataEdit?.leave_name,
          send_to: dataEdit?.send_to,
          leave_from_date: dataEdit?.leave_from_date,
          leave_from_timetype: dataEdit?.leave_from_timetype,
          leave_to_date: dataEdit?.leave_to_date,
          leave_to_timetype: dataEdit?.leave_to_timetype,
          leave_days: dataEdit?.leave_days,
          user_id: dataEdit?.user_id,
          leave_reason: dataEdit?.leave_reason,
          leave_status: status,
          approve_status: dataEdit?.approve_status,
          approve_user_id: dataEdit?.approve_user_id,
          approve_user: dataEdit?.approve_user,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      await toggleModalCancel();
      await getForm16DataTable();
    } catch (err) {
      console.error(err);
    }
  };

  const [leaveDataFromSelect, setLeaveDataFromSelect] = useState([])

  useEffect(() => {
    getLeaveDataFromSelect()
  }, [dataEdit?.leave_from_date,data?.leave_from_date])
  

  const getLeaveDataFromSelect = async () => {
    setLeaveDataFromSelect([])
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[budget_year][0]": CheckBudgetYear(),
        "filter[leave_status][0]": 0,
        "filter[leave_status][1]": 2,
        "filter[leave_status][2]": 3,
        "filter[leave_status][3]": 4,
        "filter[leave_status][4]": 5,
        "filter[leave_status][5]": 7,
        "filter[leave_status][6]": 9,
        "filter[leave_dmy_start][0]": ConvertDate(insertModal ? data?.leave_from_date : dataEdit?.leave_from_date)?.toDateISO(),
        "filter[leave_dmy_end][0]": ConvertDate(insertModal ? data?.leave_to_date : dataEdit?.leave_to_date)?.toDateISO(),
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      const resultArr = res.data?.result;
        for (const i in resultArr) {
         if (resultArr[i]?.leave_data_id !== dataEdit?.leave_data_id) {
          leaveDataFromSelect.length !== 0 ? setLeaveDataFromSelect((prev) => [...prev,resultArr[i]]) : setLeaveDataFromSelect([resultArr[i]])
         }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const toggleModalCancel = (status) => {
    if (modalCancel?.modal === false) {
      setModalCancel((prev) => ({
        ...prev,
        modal: true,
        status: status,
      }));
    } else {
      setModalCancel((prev) => ({
        ...prev,
        modal: false,
        status: "",
      }));
    }
  };

  // const [, setViewSubMenu] = useState();
  // const [viewSubMenu, setViewSubMenu] = useState();

  // useEffect(() => {
  //   setViewSubMenu(
  //     CheckSubAdmin(userInfo?.positionSubAdmin) ||
  //       CheckPosition(userInfo?.position)
  //   );
  // }, [userInfo]);

  const setFromDate = (e) => {
    setDateFilter(prev => ({
      ...prev,
      fromDate : e
    }));
  }

  const setToDate = (e) => {
    setDateFilter(prev => ({
      ...prev,
      toDate : e
    }));
  }

  const setLeaveFromDate = (e) => {
      const leaveDays = calculateLeaveDays(
        e,
        data.leave_from_timetype,
        e,
        data?.leave_to_timetype
      );
      setData((prev) => ({
        ...prev,
        leave_from_date: e,
        leave_to_date: e,
        leave_days: leaveDays,
      }));
    setData((prev) => ({
      ...prev,
      leave_from_date: e,
      leave_to_date: e,
    }));
  }

  const setLeaveToDate = (e) => {
      const leaveDays = calculateLeaveDays(
        e,
        data.leave_from_timetype,
        e,
        data?.leave_to_timetype
      );
      setData((prev) => ({
        ...prev,
        leave_from_date: e,
        leave_to_date: e,
        leave_days: leaveDays,
      }));
      setData((prev) => ({
        ...prev,
        leave_to_date: e,
      }));
  }

  const setEditLeaveFromDate = (e) => {
    const leaveDays = calculateLeaveDays(
      e,
      dataEdit?.leave_from_timetype,
      e,
      dataEdit?.leave_to_timetype
    );
    setDataEdit((prev) => ({
      ...prev,
      leave_from_date: e,
      leave_to_date: e,
      leave_days: leaveDays,
    }));
    setDataEdit((prev) => ({
      ...prev,
      leave_from_date: e,
      leave_to_date: e,
    }));
  }

  const setEditLeaveToDate = (e) => {
      const leaveDays = calculateLeaveDays(
        e,
        dataEdit?.leave_from_timetype,
        e,
        dataEdit?.leave_to_timetype
      );
      setDataEdit((prev) => ({
        ...prev,
        leave_from_date: e,
        leave_to_date: e,
        leave_days: leaveDays,
      }));
      setDataEdit((prev) => ({
        ...prev,
        leave_from_date: e,
        leave_to_date: e,
      }));
  }
  

  function filterForm() {
    return <Row className="pb-2">
    <Col xs={12} lg={3}>
      <Label>ตั้งแต่วันที่</Label>
      <NewThaiDatePicker invalidProps = {dateFilter.isValid && dateFilter.fromDate === null ? true : false} value = {dateFilter.fromDate} setValue = {setFromDate} placeholderText ={"วัน/เดือน/ปี"}/>
      {/* <MyThaiDatePick invalidProps = {dateFilter.isValid && dateFilter.fromDate === null ? true : false} setDateObj = {setFromDate}/> */}
    </Col>
    <Col xs={12} lg={3}>
      <Label>ถึงวันที่</Label>
      <NewThaiDatePicker value = {dateFilter.toDate} setValue = {setToDate} minDate = {dateFilter.fromDate} placeholderText ={"วัน/เดือน/ปี"}/>
      {/* <MyThaiDatePick setDateObj = {setToDate}/> */}
    </Col>
    <Col xs={12} lg={3} className="d-flex align-items-end mt-2">
        <Button className="btn-success me-1" 
      onClick={async (e) => {
        e.preventDefault();
         await setDateFilter(prev => ({
            ...prev,
            isValid : true
          }));
        dateFilter.isValid && dateFilter.fromDate && getForm16DataTable();
      }}>
        <i className="fa-sharp fa-solid fa-magnifying-glass pe-1"></i>ค้นหา
        </Button>
        <Button className="btn-info" 
          onClick={() => {setInsertModal(true)}}>
          <i className="fa-sharp fa-plus fa-magnifying-glass pe-1"></i>เพิ่มคำขอ
        </Button>
    </Col>
  </Row>
  }

  const [activeTab, setActiveTab] = useState("1");

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (position === "Highleader" || position === "admin") {
      setActiveTab("2")
    }
  }, [position])

  dayjs.locale("th")

  
  function generateTimeOptions() {
    const timeOptions = [];
    const incrementMinutes = 15;

    for (let hour = 0; hour < 24; hour++) {
      for (let minutes = 0; minutes < 60; minutes += incrementMinutes) {
        const timeString = `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        const isoTimeString = `T${timeString}:00.000Z`;
        timeOptions.push({
          display: timeString,
          value: isoTimeString
        });
      }
    }

    return timeOptions;
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <React.Fragment>
      <FadeIn>
        <SubMenuEntryWork menu={4} />

        <Breadcrumb
          title="หน้าหลัก"
          breadcrumbItem="ลงเวลาปฏิบัติราชการ"
          isBack={true}
          isSubMenu={true}
          subMenuName="ขอกลับก่อนเวลา"
          path="/entrywork"
        />
        <Row>
          <Col>
            <Card style={{ minHeight: "550px" }}>
              <CardBody>
                <Row className="">
                  <Col xxl={12}>
                    <h4>ตารางแสดงข้อมูลการขอกลับก่อนเวลา</h4>
                  </Col>
                </Row>
                {CheckPosition(userInfo?.position).length > 0 &&
                  (CheckPosition(userInfo?.position).includes(5) || 
                    CheckPosition(userInfo?.position).includes(4) || 
                    CheckPosition(userInfo?.position).includes(3) || 
                    CheckPosition(userInfo?.position).includes(2))  ?
                      <Col xxl={12} xs={12} className="px-0"> <EmployeeView userInfoProps={userInfo}/> </Col>
                    : (CheckPosition(userInfo?.position).length > 0 && 
                    CheckPosition(userInfo?.position).includes(7)) ||
                    (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
                    (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || 
                     CheckSubAdmin(userInfo?.positionSubAdmin).includes(2)))  ? 
                      <Fragment>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                toggle("1");
                              }}
                            >
                              <h5>
                                {activeTab === "1" ? <i className="fa-solid fa-user font-size-18 me-2"></i> : ""}
                                ตนเอง
                              </h5>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                toggle("2");
                              }}
                            >
                              <h5>
                                {activeTab === "2" ? <i className="fa-duotone fa-users font-size-18 me-2"></i> : ""}  
                                {/* <i className="fa-solid fa-books font-size-20 me-2"></i> */}
                                เจ้าหน้าที่
                              </h5>
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                              <Row className="mt-3">
                                <Col className="h-100">
                                  {/* {filterForm()} */}
                                  {filterForm()}
                                  <Table responsive style={{ verticalAlign: "middle" }}>
                                    <thead className="table-light">
                                      <tr>
                                        <th className="text-center">ลำดับ</th>
                                        <th className="text-center">วันที่แจ้ง</th>
                                        {/* <th>ชื่อฟอร์ม</th> */}
                                        <th className="text-center">ตั้งแต่วันที่</th>
                                        <th className="text-center">ถึงวันที่</th>
                                        <th style={{width : "15%"}} className="text-center">เหตุผล</th>
                                        <th className="text-center">สถานะ</th>
                                        <th className="text-center">เจ้าหน้าที่</th>
                                        <th style={{width : "15%"}}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dataForm16?.length > 0 ?
                                        dataForm16?.map((item, idx) => {

                                          let startDate = 
                                          // ConvertDate(item?.leave_from_date).toThaiDateDMY();
                                          dayjs.utc(item?.leave_from_date).format("DD MMM YYYY");

                                          let endDate = ConvertDate(
                                            item?.leave_to_date
                                          ).toThaiDateDMY();

                                          const splitTime = ConvertDate(item?.leave_from_date).toHHmmTime();

                                          return (
                                            <tr key={idx}>
                                              <td className="text-center">{idx + 1}</td>
                                              <td className="text-center">{ConvertDate(item?.created_date).toThaiDateDMY()}</td>
                                              {/* <td>{item?.leave_name}</td> */}
                                              <td className="text-center">{startDate}</td>
                                              <td className="text-center">{endDate}</td>
                                              <td>{item?.leave_reason}</td>
                                              <td className="text-center">
                                                <h5>
                                                  {leaveStatusBadge(item)}
                                                </h5>
                                              </td>
                                              <td>{item?.created_user}</td>
                                              <td className="text-center">
                                                <Tooltip title="แก้ไข">
                                                  <button
                                                    className="btn btn-warning me-2"
                                                    onClick={async () => {
                                                      await toggleModal();
                                                      getDataForm16ByID(item?.leave_data_id);
                                                    }}
                                                  >
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                  </button>
                                                </Tooltip>
                                                <Tooltip title="พิมพ์">
                                                  <button
                                                    className="btn btn-success me-2"
                                                    onClick={async () => {
                                                      await handleGetReport(
                                                        item?.leave_type_id,
                                                        item?.leave_data_id
                                                      );
                                                      if (reportURL) {
                                                        window.open(reportURL);
                                                        reportURL = "";
                                                      }
                                                    }}
                                                  >
                                                    <i className="fa-solid fa-print"></i>
                                                  </button>
                                                </Tooltip>
                                                <Tooltip title="ยกเลิก">
                                                  <button
                                                    className="btn btn-danger me-2"
                                                    onClick={() => {
                                                      getDataForm16ByID(item?.leave_data_id);
                                                      toggleModalCancel("8");
                                                    }}
                                                  >
                                                    <i className="fa-solid fa-trash"></i>
                                                  </button>
                                                </Tooltip>
                                              </td>
                                            </tr>
                                          );
                                        })
                                      :
                                      <tr>
                                        <td colSpan={8} className="text-center fs-5">
                                          ไม่มีข้อมูล
                                        </td>
                                      </tr>
                                      }
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row> 
                              {dataForm16?.length === 0 ? null : (
                                <Row
                                  className="mx-2"
                                  style={{
                                    display: "flex",
                                    alignItems: "end",
                                  }}
                                >
                                  <Col xxl={4} className="mb-2">
                                    <h4>
                                      <Badge className="badge-soft-primary me-1">
                                        ทั้งหมด {totalRows} รายการ
                                      </Badge>
                                    </h4>
                                  </Col>
                                  <Col xxl={8} className="d-flex justify-content-end">
                                    <Pagination aria-label="Page navigation example">
                                      <PaginationItem disabled={currentPage === 1}>
                                        <PaginationLink onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, 1)}>
                                          หน้าแรก
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === 1}>
                                        <PaginationLink
                                          onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, currentPage - 1)}
                                        >
                                          ย้อนกลับ
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem active>
                                        <PaginationLink>
                                          หน้า {currentPage} จาก {totalPage}
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === totalPage}>
                                        <PaginationLink
                                          onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, currentPage + 1)}
                                        >
                                          ถัดไป
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === totalPage}>
                                        <PaginationLink
                                          onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, totalPage)}
                                        >
                                          หน้าสุดท้าย
                                        </PaginationLink>
                                      </PaginationItem>
                                    </Pagination>
                                  </Col>
                                </Row>
                              )}
                          </TabPane>
                          <TabPane tabId="2">
                            <EmployeeView userInfoProps={userInfo}/>
                          </TabPane>
                        </TabContent>
                      </Fragment>
                    : 
                      <Fragment>
                        <Row className="mt-3">
                                <Col className="h-100">
                                  {/* {filterForm()} */}
                                  {filterForm()}
                                  <Table responsive style={{ verticalAlign: "middle" }}>
                                    <thead className="table-light">
                                      <tr>
                                        <th className="text-center">ลำดับ</th>
                                        <th className="text-center">วันที่แจ้ง</th>
                                        {/* <th>ชื่อฟอร์ม</th> */}
                                        <th className="text-center">ตั้งแต่วันที่</th>
                                        <th className="text-center">ถึงวันที่</th>
                                        <th style={{width : "15%"}} className="text-center">เหตุผล</th>
                                        <th className="text-center">สถานะ</th>
                                        <th className="text-center">เจ้าหน้าที่</th>
                                        <th style={{width : "15%"}}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dataForm16?.length > 0 ?
                                        dataForm16?.map((item, idx) => {

                                          let startDate = 
                                          // ConvertDate(item?.leave_from_date).toThaiDateDMY();
                                          dayjs.utc(item?.leave_from_date).format("DD MMM YYYY");

                                          let endDate = ConvertDate(
                                            item?.leave_to_date
                                          ).toThaiDateDMY();

                                          const splitTime = ConvertDate(item?.leave_from_date).toHHmmTime();

                                          return (
                                            <tr key={idx}>
                                              <td className="text-center">{idx + 1}</td>
                                              <td className="text-center">{ConvertDate(item?.created_date).toThaiDateDMY()}</td>
                                              {/* <td>{item?.leave_name}</td> */}
                                              <td className="text-center">{startDate}</td>
                                              <td className="text-center">{endDate}</td>
                                              <td>{item?.leave_reason}</td>
                                              <td className="text-center">
                                                <h5>
                                                  {leaveStatusBadge(item)}
                                                </h5>
                                              </td>
                                              <td>{item?.created_user}</td>
                                              <td className="text-center">
                                                <Tooltip title="แก้ไข">
                                                  <button
                                                    className="btn btn-warning me-2"
                                                    onClick={async () => {
                                                      await toggleModal();
                                                      getDataForm16ByID(item?.leave_data_id);
                                                    }}
                                                  >
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                  </button>
                                                </Tooltip>
                                                <Tooltip title="พิมพ์">
                                                  <button
                                                    className="btn btn-success me-2"
                                                    onClick={async () => {
                                                      await handleGetReport(
                                                        item?.leave_type_id,
                                                        item?.leave_data_id
                                                      );
                                                      if (reportURL) {
                                                        window.open(reportURL);
                                                        reportURL = "";
                                                      }
                                                    }}
                                                  >
                                                    <i className="fa-solid fa-print"></i>
                                                  </button>
                                                </Tooltip>
                                                <Tooltip title="ยกเลิก">
                                                  <button
                                                    className="btn btn-danger me-2"
                                                    onClick={() => {
                                                      getDataForm16ByID(item?.leave_data_id);
                                                      toggleModalCancel("8");
                                                    }}
                                                  >
                                                    <i className="fa-solid fa-trash"></i>
                                                  </button>
                                                </Tooltip>
                                              </td>
                                            </tr>
                                          );
                                        })
                                      :
                                      <tr>
                                        <td colSpan={8} className="text-center fs-5">
                                          ไม่มีข้อมูล
                                        </td>
                                      </tr>
                                      }
                                    </tbody>
                                  </Table>
                                </Col>
                        </Row> 
                        {dataForm16?.length === 0 ? null : (
                                <Row
                                  className="mx-2"
                                  style={{
                                    display: "flex",
                                    alignItems: "end",
                                  }}
                                >
                                  <Col xxl={4} className="mb-2">
                                    <h4>
                                      <Badge className="badge-soft-primary me-1">
                                        ทั้งหมด {totalRows} รายการ
                                      </Badge>
                                    </h4>
                                  </Col>
                                  <Col xxl={8} className="d-flex justify-content-end">
                                    <Pagination aria-label="Page navigation example">
                                      <PaginationItem disabled={currentPage === 1}>
                                        <PaginationLink onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, 1)}>
                                          หน้าแรก
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === 1}>
                                        <PaginationLink
                                          onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, currentPage - 1)}
                                        >
                                          ย้อนกลับ
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem active>
                                        <PaginationLink>
                                          หน้า {currentPage} จาก {totalPage}
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === totalPage}>
                                        <PaginationLink
                                          onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, currentPage + 1)}
                                        >
                                          ถัดไป
                                        </PaginationLink>
                                      </PaginationItem>
                                      <PaginationItem disabled={currentPage === totalPage}>
                                        <PaginationLink
                                          onClick={() => getForm16DataTable(CheckSubAdmin(userInfo?.positionSubAdmin) && true, totalPage)}
                                        >
                                          หน้าสุดท้าย
                                        </PaginationLink>
                                      </PaginationItem>
                                    </Pagination>
                                  </Col>
                                </Row>
                         )}
                      </Fragment>
                  }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </FadeIn>
      <Modal centered isOpen={modalCancel?.modal} toggle={toggleModalCancel}>
        <ModalHeader toggle={toggleModalCancel}>
          {modalCancel?.status === "8"
            ? "ยกเลิกการขอออกก่อนเวลา"
            : "ขอยกเลิกการขอออกก่อนเวลา"}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={12}>
              <Row>
                <Col xs={12} className="d-flex justify-content-center">
                  <h3>คุณต้องยกเลิกการขอออกก่อนเวลานี้หรือไม่</h3>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: deleteTrash?.default,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    width={200}
                    height={200}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row
            className="mt-4"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <Col xxl={3}>
              <Button
                onClick={() => {
                  handleCancelLeave(
                    dataEdit?.leave_data_id,
                    modalCancel?.status
                  );
                }}
                className="w-100"
                color="success"
              >
                ตกลง
              </Button>
            </Col>
            <Col xxl={3}>
              <Button
                className="w-100"
                color="secondary"
                onClick={toggleModalCancel}
              >
                ย้อนกลับ
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal centered isOpen={confirmSend} toggle={toggleConfirm}>
        <ModalHeader toggle={toggleConfirm}>ยืนยันการส่งฟอร์ม</ModalHeader>
        <ModalBody>
          <Row>
            <Col xxl={12} className="d-flex justify-content-center">
              <h4>ยืนยันที่จะส่งคำขอกลับก่อนเวลาใช่ไหม?</h4>
            </Col>
            <Col className="d-flex justify-content-end">
              <Button
                className="me-2 w-25"
                color="success"
                onClick={handleSubmit}
              >
                ตกลง
              </Button>
              <Button className="w-25" color="danger" onClick={toggleConfirm}>
                ปิด
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={editModal} backdrop= {"static"} toggle={toggleModal} centered size="lg">
        <ModalHeader toggle={toggleModal}>
          แก้ไขการขออนุญาตกลับก่อนเวลา
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              await handleEdit(dataEdit?.leave_data_id);
              await toggleModal();
            }}
          >
            <FormGroup row className="d-flex justify-content-end">
              <Label className="text-end my-0 py-0" xxl={2}>
                เขียนที่ :
              </Label>
              <Label className="text-start my-0 py-0" xxl={2}>
                {dataEdit?.write_place}
              </Label>
            </FormGroup>
            <FormGroup row className="d-flex justify-content-end">
              <Label className="text-end my-0 py-0" xxl={2}>
                วันที่เขียน :
              </Label>
              <Label className="text-start my-0 py-0" xxl={2}>
                {ConvertDate(dataEdit?.write_date).toThaiDateDMY()}
              </Label>
            </FormGroup>
            <FormGroup row>
              <Label xxl={2} className="text-end my-0 py-0">
                เรื่อง :
              </Label>
              <Label xxl={6} className="text-start my-0 py-0">
                {dataEdit?.leave_name}
              </Label>
            </FormGroup>
            <FormGroup row>
              <Label xxl={2} className="text-end my-0 py-0">
                เรียน :
              </Label>
              <Label xxl={3} className="text-start my-0 py-0">
                {dataEdit?.send_to}
              </Label>
            </FormGroup>
            {/* <FormGroup row>
              <Label className="text-end my-0 py-0" xxl={2}>
                ชื่อ-นามสกุล :
              </Label>
              <Label className="text-start my-0 py-0" xxl={4}>
                {data?.user_name}
              </Label>
            </FormGroup>
            <FormGroup row>
              <Label className="text-end my-0 py-0" xxl={2}>
                ตำแหน่ง :
              </Label>
              <Label className="text-start my-0 py-0" xxl={4}>
                {data?.user_position_name}
              </Label>
              <Label className="text-end my-0 py-0" xxl={2}>
                สังกัด :
              </Label>
              <Label className="text-start my-0 py-0" xxl={4}>
                {data?.cont_to_name_1}
              </Label>
            </FormGroup> */}
            <FormGroup row>
              <Label className="text-end" xxl={2}>
              <span className="me-1 text-danger">*</span>เนื่องจาก :
              </Label>
              <Col xxl={10}>
                <Input
                  value={dataEdit?.leave_reason}
                  style={{ height: "75px" }}
                  type="textarea"
                  onChange={(e) => {
                    setDataEdit((prev) => ({
                      ...prev,
                      leave_reason: e.target.value,
                    }));
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label className="text-end" xxl={2}>
                วันที่ :
              </Label>
              <Col xxl={3}>
                {/* <Flatpickr
                  className="form-control d-block"
                  placeholder="วัน/เดือน/ปี"
                  options={{
                    dateFormat: "d-m-Y",
                    ariaDateFormat: "F j, Y",
                    locale: "th",
                  }}
                  value={dataEdit?.leave_from_date}
                  onChange={(e) => {
                    if (dataEdit.leave_to_date !== null) {
                      const leaveDays = calculateLeaveDays(
                        e[0],
                        dataEdit.leave_from_timetype,
                        e[0],
                        dataEdit?.leave_to_timetype
                      );
                      setDataEdit((prev) => ({
                        ...prev,
                        leave_from_date: e[0],
                        leave_to_date: e[0],
                        leave_days: leaveDays,
                      }));
                    }
                    setDataEdit((prev) => ({
                      ...prev,
                      leave_from_date: e[0],
                      leave_to_date: e[0],
                    }));
                  }}
                /> */}
              <NewThaiDatePicker value = {dataEdit?.leave_from_date} setValue = {setEditLeaveFromDate} returnType = {"DateTime"} placeholderText ={"วัน/เดือน/ปี"}/>
              </Col>
              <Label className="text-end" xxl={1}>
                เวลา :
              </Label>
              <Col xxl={2}>
                {/* <Input
                  type="select"
                  value={dataEdit?.leave_from_timetype}
                  onChange={(e) => {
                    if (dataEdit?.leave_from_date && dataEdit?.leave_to_date) {
                      const leaveDays = calculateLeaveDays(
                        new Date(
                          new Date(dataEdit?.leave_from_date).setHours(
                            0,
                            0,
                            0,
                            0
                          )
                        ),
                        e?.target?.value,
                        new Date(
                          new Date(dataEdit?.leave_from_date).setHours(
                            0,
                            0,
                            0,
                            0
                          )
                        ),
                        dataEdit?.leave_to_timetype
                      );

                      setDataEdit((prev) => ({
                        ...prev,
                        leave_from_timetype: e?.target?.value,
                        leave_days: leaveDays,
                      }));
                    }
                    setDataEdit((prev) => ({
                      ...prev,
                      leave_from_timetype: e?.target?.value,
                    }));
                  }}
                >
                  <option value="1">9.30</option>
                  <option value="2">13.00</option>
                </Input> */}
                <Input
                      type="select"
                      value={editLeaveTime}
                      onChange={async (e) => {
                        if (data?.leave_from_date && data?.leave_to_date) {
                          const leaveDays = calculateLeaveDays(
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            "1",
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            "2"
                          );

                          setData((prev) => ({
                            ...prev,
                            leave_from_timetype: "1",
                            leave_to_timetype: "2",
                            leave_days: leaveDays,
                          }));
                        }
                        await setEditLeaveTime(e.target.value)
                      }}
                    >
                      {generateTimeOptions().map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.display}
                        </option>
                      ))}
                    </Input>
              </Col>
            </FormGroup>
            {/* <FormGroup row>
              <Label className="text-end" xxl={2}>
                ถึงวันที่
              </Label>
              <Col xxl={3}> */}
                {/* <Flatpickr
                  className="form-control d-block"
                  placeholder="วัน/เดือน/ปี"
                  options={{
                    dateFormat: "d-m-Y",
                    ariaDateFormat: "F j, Y",
                    locale: "th",
                  }}
                  value={dataEdit?.leave_to_date}
                  onChange={(e) => {
                    if (dataEdit.leave_to_date !== null) {
                      const leaveDays = calculateLeaveDays(
                        e[0],
                        data.leave_from_timetype,
                        e[0],
                        data?.leave_to_timetype
                      );
                      setDataEdit((prev) => ({
                        ...prev,
                        leave_from_date: e[0],
                        leave_to_date: e[0],
                        leave_days: leaveDays,
                      }));
                    }
                    setDataEdit((prev) => ({
                      ...prev,
                      leave_from_date: e[0],
                      leave_to_date: e[0],
                    }));
                  }}
                /> */}
                {/* <NewThaiDatePicker value = {dataEdit?.leave_to_date} minDate = {dataEdit?.leave_from_date} maxDate = {dataEdit?.leave_from_date} setValue = {setEditLeaveToDate} returnType = {"DateTime"} placeholderText ={"วัน/เดือน/ปี"}/>
              </Col>
              <Label className="text-end" xxl={1}>
                เวลา
              </Label>
              <Col xxl={2}>
                <Input
                  type="select"
                  value={dataEdit?.leave_to_timetype}
                  onChange={(e) => {
                    if (dataEdit?.leave_from_date && dataEdit?.leave_to_date) {
                      const leaveDays = calculateLeaveDays(
                        new Date(
                          new Date(dataEdit?.leave_from_date).setHours(0, 0, 0, 0)
                        ),
                        dataEdit?.leave_from_timetype,
                        new Date(
                          new Date(dataEdit?.leave_from_date).setHours(0, 0, 0, 0)
                        ),
                        e?.target?.value
                      );

                      setDataEdit((prev) => ({
                        ...prev,
                        leave_to_timetype: e?.target?.value,
                        leave_days: leaveDays,
                      }));
                    }
                    setDataEdit((prev) => ({
                      ...prev,
                      leave_to_timetype: e?.target?.value,
                    }));
                  }}
                >
                  <option value="1">12.00</option>
                  <option value="2">17.30</option>
                </Input>
              </Col>
            </FormGroup> */}
            {/* <FormGroup row>
              <Label className="text-end" xxl={2}>
                มีกำหนด :
              </Label>
              <Label className="text-start" xxl={2}>
                {dataEdit?.leave_days} วัน
              </Label>
            </FormGroup> */}
            {leaveDataFromSelect.length !== 0 ? (
              <FormGroup row>
                <Label className="text-end text-danger" xxl={3} lg={3} md={3}>
                 คุณมีการลาในช่วงวันที่เลือก
                </Label>
                <Col xxl={8} lg={9} md={9}>
                  {leaveDataFromSelect?.map((item, idx) => {
                  return (
                    <Input
                      disabled key={idx}
                      style={{ textAlign: "start" }} 
                      className="text-danger mb-1"
                      value={
                        `${item?.leave_name} วันที่ ${ConvertDate(item.leave_from_date).toOnlyDateTHYear()} เวลา ${item?.leave_from_timetype === "1" ? "9.30" : "13.00"} น. ถึง ${
                          ConvertDate(item.leave_to_date).toOnlyDateTHYear()} เวลา ${item?.leave_to_timetype === "1" ? "12.00" : "17.30"} น.`
                      }
                    />
                  );
                  })}
                </Col>
              </FormGroup>
            ) : null}
            <FormGroup row>
              <Label className="text-end" xxl={2}>
                ส่งผู้อนุมัติ
              </Label>
              <Col xxl={4}>
                <Input disabled value={data?.approve_user} type="text" />
              </Col>
            </FormGroup>
            <FormGroup className="d-flex justify-content-end">
              <Col xxl={4} className="d-flex">
                <Button type="submit" color="warning" className="w-100">
                  แก้ไข
                </Button>
                <Button
                  color="danger"
                  className="ms-2 w-100"
                  onClick={() => {
                    toggleModal();
                  }}
                >
                  ปิด
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={insertModal} backdrop= {"static"} toggle = {true} centered size="lg">
      <ModalHeader toggle={() => {setInsertModal(false)}}>
          แบบฟอร์มขออนุญาตกลับก่อนเวลา
        </ModalHeader>
        <ModalBody>
        <Col className="mb-0 pb-0 ">
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  toggleConfirm();
                }}
              >
                <FormGroup row className="d-flex justify-content-end">
                  <Label className="text-end my-0 py-0" xs={8} xxl={3}>
                    เขียนที่ :
                  </Label>
                  <Label className="text-start my-0 py-0" xs={4} xxl={3}>
                    {data?.writeFrom}
                  </Label>
                </FormGroup>
                <FormGroup row className="d-flex justify-content-end">
                  <Label className="text-end my-0 py-0" xs={8} xxl={3}>
                    วันที่เขียน :
                  </Label>
                  <Label className="text-start my-0 py-0" xs={4} xxl={3}>
                    {ConvertDate(data?.writeDate).toThaiDateDMY()}
                  </Label>
                </FormGroup>
                <FormGroup row>
                  <Label xs={3} xxl={3} className="text-end my-0 py-0">
                    เรื่อง :
                  </Label>
                  <Label xs={9} xxl={9} className="text-start my-0 py-0">
                    ขออนุญาตออกงานก่อนเวลา
                  </Label>
                  <Label xs={3} xxl={3} className="text-end my-0 py-0">
                    เรียน :
                  </Label>
                  <Label xs={9} xxl={9} className="text-start my-0 py-0">
                    ผู้อำนวยการสำนักงานเลขาธิการ
                  </Label>
                  <Label className="text-end my-0 py-0" xs={3} xxl={3}>
                    ชื่อ-นามสกุล :
                  </Label>
                  <Label className="text-start my-0 py-0" xs={9} xxl={9}>
                    {data?.user_name}
                  </Label>
                  <Label className="text-end my-0 py-0" xs={3} xxl={3}>
                    ตำแหน่ง :
                  </Label>
                  <Label className="text-start my-0 py-0" xs={9} xxl={9}>
                    {data?.user_position_name === "0" || !data?.user_position_name ? "-" : data?.user_position_name}
                  </Label>
                  <Label className="text-end my-0 py-0" xs={3} xxl={3}>
                    สังกัด :
                  </Label>
                  <Label className="text-start my-0 py-0" xs={9} xxl={9}>
                    {data?.cont_to_name_1}
                  </Label>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                  <span className="me-1 text-danger">*</span>เนื่องจาก :
                  </Label>
                  <Col xs={9} xxl={9}>
                    <Input
                      required
                      value={data?.leave_reason}
                      style={{ height: "75px" }}
                      type="textarea"
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          leave_reason: e.target.value,
                        }));
                      }}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    {/* ตั้งแต่ */}
                    วันที่ :
                  </Label>
                  <Col xs={9} xxl={4} className={`${windowSize.width < 1400 ? "mb-2" : ""}`}>
                    {/* <Flatpickr
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      options={{
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      value={data?.leave_from_date}
                      onChange={(e) => {
                        if (data.leave_to_date !== null) {
                          const leaveDays = calculateLeaveDays(
                            e[0],
                            data.leave_from_timetype,
                            e[0],
                            data?.leave_to_timetype
                          );
                          setData((prev) => ({
                            ...prev,
                            leave_from_date: e[0],
                            leave_to_date: e[0],
                            leave_days: leaveDays,
                          }));
                        }
                        setData((prev) => ({
                          ...prev,
                          leave_from_date: e[0],
                          leave_to_date: e[0],
                        }));
                      }}
                    /> */}
                    <NewThaiDatePicker value = {data?.leave_from_date} setValue = {setLeaveFromDate} returnType = {"DateTime"} placeholderText ={"วัน/เดือน/ปี"}/>
                    {data.leave_days === 0 && <span className="text-danger">กรุณาเลือกวันที่ถูกต้อง</span>}
                  </Col>
                  <Label className="text-end" xs={3} xxl={2}>
                    เวลา :
                  </Label>
                  <Col xs={9} xxl={3} className={`${windowSize.width < 1400 ? "mb-2" : ""}`}>
                  {/* <Input
                      type="select"
                      value={data?.leave_from_timetype}
                      onChange={(e) => {
                        if (data?.leave_from_date && data?.leave_to_date) {
                          const leaveDays = calculateLeaveDays(
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            e?.target?.value,
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            data?.leave_to_timetype
                          );

                          setData((prev) => ({
                            ...prev,
                            leave_from_timetype: e?.target?.value,
                            leave_days: leaveDays,
                          }));
                        }
                        setData((prev) => ({
                          ...prev,
                          leave_from_timetype: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="1">9.30</option>
                      <option value="2">13.00</option>
                    </Input> */}
                    <Input
                      type="select"
                      value={leaveTime}
                      onChange={async (e) => {
                        if (data?.leave_from_date && data?.leave_to_date) {
                          const leaveDays = calculateLeaveDays(
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            "1",
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            "2"
                          );

                          setData((prev) => ({
                            ...prev,
                            leave_from_timetype: "1",
                            leave_to_timetype: "2",
                            leave_days: leaveDays,
                          }));
                        }
                        await setLeaveTime(e.target.value)
                      }}
                    >
                      {generateTimeOptions().map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.display}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </FormGroup>
                {/* <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    ถึงวันที่ :
                  </Label>
                  <Col xxl={4}> */}
                    {/* <Flatpickr
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      options={{
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      value={data?.leave_to_date}
                      onChange={(e) => {
                        if (data.leave_to_date !== null) {
                          const leaveDays = calculateLeaveDays(
                            e[0],
                            data.leave_from_timetype,
                            e[0],
                            data?.leave_to_timetype
                          );
                          setData((prev) => ({
                            ...prev,
                            leave_from_date: e[0],
                            leave_to_date: e[0],
                            leave_days: leaveDays,
                          }));
                        }
                        setData((prev) => ({
                          ...prev,
                          leave_to_date: e[0],
                        }));
                      }}
                    /> */}
                    {/* <NewThaiDatePicker value = {data?.leave_to_date} minDate = {data?.leave_from_date} maxDate = {data?.leave_from_date} setValue = {setLeaveToDate} returnType = {"DateTime"} placeholderText ={"วัน/เดือน/ปี"}/>
                  </Col>
                  <Label className="text-end" xxl={2}>
                    เวลา :
                  </Label>
                  <Col xxl={3}>
                    <Input
                      type="select"
                      value={data?.leave_to_timetype}
                      onChange={(e) => {
                        if (data?.leave_from_date && data?.leave_to_date) {
                          const leaveDays = calculateLeaveDays(
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            data?.leave_from_timetype,
                            new Date(
                              new Date(data?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            e?.target?.value
                          );

                          setData((prev) => ({
                            ...prev,
                            leave_to_timetype: e?.target?.value,
                            leave_days: leaveDays,
                          }));
                        }
                        setData((prev) => ({
                          ...prev,
                          leave_to_timetype: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="1">12.00</option>
                      <option value="2">17.30</option>
                    </Input>
                  </Col>
                </FormGroup> */}
                {/* <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    มีกำหนด :
                  </Label>
                  <Label className="text-start" xxl={2}>
                    {data?.leave_days} วัน
                  </Label>
                </FormGroup> */}
                {leaveDataFromSelect.length !== 0 ? (
                <FormGroup row>
                  <Label className="text-end text-danger" xs={3} xxl={3} lg={3} md={3}>
                   คุณมีการลาในวันที่เลือก
                  </Label>
                  <Col xs={9} xxl={8} lg={9} md={9}>
                    {leaveDataFromSelect?.map((item, idx) => {
                    return (
                      <Input
                        disabled key={idx}
                        style={{ textAlign: "start" }} 
                        className="text-danger mb-1"
                        value={
                          `${item?.leave_name} วันที่ ${ConvertDate(item.leave_from_date).toOnlyDateTHYear()} เวลา ${item?.leave_from_timetype === "1" ? "9.30" : "13.00"} น. ถึง ${ConvertDate(item.leave_to_date).toOnlyDateTHYear()} เวลา ${item?.leave_to_timetype === "1" ? "12.00" : "17.30"} น.`
                        }
                      />
                    );
                    })}
                  </Col>
                </FormGroup>
                ) : null}
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    ส่งผู้อนุมัติ :
                  </Label>
                  <Col xs={9} xxl={5}>
                    <Input disabled value={data?.approve_user} type="text" />
                  </Col>
                </FormGroup>
                <FormGroup className="d-flex justify-content-end">
                  <Col xxl={4} className="d-flex">
                    <Button disabled = {leaveDataFromSelect.length !== 0 || data.leave_days === 0} type="submit" color="success" className="w-100">
                      บันทึก
                    </Button>
                    <Button
                      color="warning"
                      className="ms-2 w-100"
                      onClick={() => {
                        resetData();
                      }}
                    >
                      ล้าง
                    </Button>
                    <Button
                      color="danger"
                      className="ms-2 w-100"
                      onClick={() => {
                        setInsertModal(false)
                      }}
                    >
                      ปิด
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
          </Col>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default Menu5;
